import PageTitle from "components/PageTitle";
import React, { useEffect, useState } from "react";

import {
  Badge,
  Button,
  Card,
  Dropdown,
  DropdownButton,
  Toast,
} from "react-bootstrap";

import {
  getCamposPrograma,
  syncCamposPrograma,
} from "../../../helpers/api/programa-conf";

import { ConfCampoLivre } from "./components/ConfCampoLivre";
import { ConfCampoSelecao } from "./components/ConfCampoSelecao";
import { ConfCampoBoolean } from "./components/ConfBoolean";
import { ConfCampoData } from "./components/ConfData";
import { ConfCampoIntervaloData } from "./components/ConfCampoIntervaloData";

export enum ETipoCampo {
  texto = 1,
  texto_multilinha = 2,
  selecao = 3,
  data = 4,
  booleano = 5,
  intervalo_data = 6,
  selecao_multipla = 7,
}

interface ICampo {
  id?: number;

  nome: string;

  tipocampo_id: number;

  obrigatorio: boolean;

  configuracao: any;

  opcoes?: any[];
}

export default function ProgramaConf() {
  const [campos, setCampos] = useState<ICampo[]>([]);
  const [warning, setWarning] = useState(false);
  useEffect(() => {
    carregar();
  }, []);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [salvarDisplay, setSalvarDisplay] = useState(false);
  async function carregar() {
    const response = await getCamposPrograma();
    console.log(response.data);
    setCampos(response.data);
  }

  function criarCampo(tipocampo_id: ETipoCampo) {
    const novoCampo: ICampo = {
      nome: "",

      tipocampo_id,

      obrigatorio: false,

      configuracao: {},

      opcoes: [],
    };

    if (tipocampo_id === ETipoCampo.texto_multilinha) {
      novoCampo.configuracao = {
        multilinha: true,
      };
    }

    if (tipocampo_id === ETipoCampo.booleano) {
      novoCampo.configuracao = {
        valorPadrao: false,
      };
    }

    setCampos((old) => [...old, novoCampo]);
  }

  function atualizarCampo(index: number, alteracoes: Partial<ICampo>) {
    setCampos((old) =>
      old.map((campo, i) =>
        i === index
          ? {
              ...campo,
              ...alteracoes,
            }
          : campo,
      ),
    );
  }

  function atualizarConfiguracao(index: number, alteracoes: any) {
    setCampos((old) =>
      old.map((campo, i) =>
        i === index
          ? {
              ...campo,
              configuracao: {
                ...campo.configuracao,
                ...alteracoes,
              },
            }
          : campo,
      ),
    );
  }

  function removerCampo(index: number) {
    setCampos((old) => old.filter((_, i) => i !== index));
  }

  async function salvar() {
    console.log("dsdsfdfa", campos);
    const payload = campos.map((campo, ordem) => ({
      ...campo,
      ordem,
      opcoes: campo.opcoes || [],
    }));
    console.log(payload);
    await syncCamposPrograma(payload);

    await carregar();
  }

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          {
            label: "Currículo",
            path: "#",
          },
          {
            label: "Configuração de Programa",
            path: "/curriculo/conf-programa",
            active: true,
          },
        ]}
        title="Configuração de Programas"
      />
      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 1050,
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={2000}
          autohide
          bg={toastType === "success" ? "success" : "danger"}
        >
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </div>
      <div
        className="mb-3"
        style={{
          display: "flex",
          justifyContent: "right",
        }}
      >
        <DropdownButton
          title={
            <>
              <i className="mdi mdi-plus-circle me-1" />
              Criar Campo
            </>
          }
        >
          <Dropdown.Item onClick={() => criarCampo(ETipoCampo.texto)}>
            Campo Livre
          </Dropdown.Item>

          <Dropdown.Item onClick={() => criarCampo(ETipoCampo.selecao)}>
            Seleção
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => criarCampo(ETipoCampo.selecao_multipla)}
          >
            Seleção Múltipla
          </Dropdown.Item>
          <Dropdown.Item onClick={() => criarCampo(ETipoCampo.booleano)}>
            Sim ou Não
          </Dropdown.Item>

          <Dropdown.Item onClick={() => criarCampo(ETipoCampo.data)}>
            Data
          </Dropdown.Item>

          <Dropdown.Item onClick={() => criarCampo(ETipoCampo.intervalo_data)}>
            Intervalo de Datas
          </Dropdown.Item>
        </DropdownButton>
      </div>
      <span
        style={{
          fontSize: "20px",
          cursor: "pointer",
        }}
        onClick={() => {
          setWarning((prev) => !prev);
        }}
      >
        <Badge bg={"warning"} pill={false}>
          ATENÇÃO
          <span
            style={{
              fontSize: "21px",
            }}
          >
            {warning ? (
              <i className="mdi mdi-chevron-up" />
            ) : (
              <i className="mdi mdi-chevron-down" />
            )}
          </span>
        </Badge>
      </span>
      {warning && (
        <Card
          bg={"warning"}
          text="white"
          style={{
            maxWidth: "50%",
          }}
        >
          <Card.Body>
            <Card.Text>
              Essa configuração gerencia toda a estrutura de Programas. Apagar
              qualquer campo implica na perda de todos os registros a ele
              associados. Entre apagar e criar um campo novo, e editar o campo,
              prefira editar.
            </Card.Text>
          </Card.Body>
        </Card>
      )}

      <div
        style={{
          marginTop: "10px",
        }}
      >
        <Card>
          <Card.Body>
            <i className="mdi mdi-lock-outline me-1" />
            Título - Campo Livre
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <i className="mdi mdi-lock-outline me-1" />
            Categoria - Campo Seleção
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <i className="mdi mdi-lock-outline me-1" />
            Alvos - Campo Livre Múltiplo
          </Card.Body>
        </Card>
      </div>

      {campos.map((campo, index) => (
        <div key={campo.id ?? index} className="mb-3">
          {(campo.tipocampo_id === ETipoCampo.texto ||
            campo.tipocampo_id === ETipoCampo.texto_multilinha) && (
            <ConfCampoLivre
              titulo={campo.nome}
              onDelete={() => removerCampo(index)}
              multilinha={campo.tipocampo_id === ETipoCampo.texto_multilinha}
              obrigatorio={campo.obrigatorio}
              onTitleChange={(titulo) =>
                atualizarCampo(index, {
                  nome: titulo,
                })
              }
              onSwitchChange={(multilinha) =>
                atualizarCampo(index, {
                  tipocampo_id: multilinha
                    ? ETipoCampo.texto_multilinha
                    : ETipoCampo.texto,
                })
              }
              onRequiredChange={(obrigatorio) =>
                atualizarCampo(index, {
                  obrigatorio,
                })
              }
            />
          )}

          {(campo.tipocampo_id === ETipoCampo.selecao ||
            campo.tipocampo_id === ETipoCampo.selecao_multipla) && (
            <ConfCampoSelecao
              titulo={campo.nome}
              onDelete={() => removerCampo(index)}
              obrigatorio={campo.obrigatorio}
              opcoes={campo.opcoes ?? []}
              multipla={campo.tipocampo_id === ETipoCampo.selecao_multipla}
              novaOpcao={campo.configuracao?.novaOpcao ?? ""}
              onTitleChange={(titulo) =>
                atualizarCampo(index, {
                  nome: titulo,
                })
              }
              onOptionsChange={(opcoes) => {
                atualizarCampo(index, {
                  opcoes,
                });
              }}
              onNovaOpcaoChange={(novaOpcao) =>
                atualizarConfiguracao(index, {
                  novaOpcao,
                })
              }
              onRequiredChange={(obrigatorio) =>
                atualizarCampo(index, {
                  obrigatorio,
                })
              }
            />
          )}

          {campo.tipocampo_id === ETipoCampo.booleano && (
            <ConfCampoBoolean
              titulo={campo.nome}
              obrigatorio={campo.obrigatorio}
              onDelete={() => removerCampo(index)}
              valorPadrao={campo.configuracao?.valorPadrao ?? false}
              onTitleChange={(titulo) =>
                atualizarCampo(index, {
                  nome: titulo,
                })
              }
              onValueChange={(valor) =>
                atualizarConfiguracao(index, {
                  valorPadrao: valor,
                })
              }
              onRequiredChange={(obrigatorio) =>
                atualizarCampo(index, {
                  obrigatorio,
                })
              }
            />
          )}

          {campo.tipocampo_id === ETipoCampo.data && (
            <ConfCampoData
              titulo={campo.nome}
              obrigatorio={campo.obrigatorio}
              onDelete={() => removerCampo(index)}
              onTitleChange={(titulo) =>
                atualizarCampo(index, {
                  nome: titulo,
                })
              }
              onRequiredChange={(obrigatorio) =>
                atualizarCampo(index, {
                  obrigatorio,
                })
              }
            />
          )}

          {campo.tipocampo_id === ETipoCampo.intervalo_data && (
            <ConfCampoIntervaloData
              titulo={campo.nome}
              obrigatorio={campo.obrigatorio}
              onDelete={() => removerCampo(index)}
              onTitleChange={(titulo) =>
                atualizarCampo(index, {
                  nome: titulo,
                })
              }
              onRequiredChange={(obrigatorio) =>
                atualizarCampo(index, {
                  obrigatorio,
                })
              }
            />
          )}
        </div>
      ))}

      <div
        style={{
          position: "fixed",
          bottom: "20px",
          zIndex: 9999,
        }}
      >
        <Button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: salvarDisplay ? "5%" : "50%",
            opacity: salvarDisplay ? 1 : 0.90,
            transition: "all 0.3s ease",
          }}
          variant="success"
          onMouseOver={() => setSalvarDisplay(true)}
          onMouseOut={() => setSalvarDisplay(false)}
          onClick={async () => {
            try {
              await salvar();
              setToastType("success");
              setToastMessage("Salvo com sucesso!");
              setShowToast(true);
            } catch {
              setToastType("");
              setToastMessage("Erro ao salvar formulário");
              setShowToast(true);
            }
          }}
        >
          <i className="mdi mdi-content-save" />

          <span
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginLeft: salvarDisplay ? "0.25rem" : "0",
              maxWidth: salvarDisplay ? "60px" : "0",
              opacity: salvarDisplay ? 1 : 0,
              transition: "all 0.3s ease",
            }}
          >
            Salvar
          </span>
        </Button>
      </div>
    </>
  );
}
